var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brief"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.91602 12.6428V4.58317C2.91602 3.6627 3.66221 2.9165 4.58268 2.9165H15.416C16.3365 2.9165 17.0827 3.6627 17.0827 4.58317V16.6665C17.0827 17.587 16.3365 18.3332 15.416 18.3332H8.60635C8.16434 18.3332 7.74042 18.1576 7.42786 17.845L3.40417 13.8213C3.09161 13.5088 2.91602 13.0848 2.91602 12.6428Z",
    stroke: "#6B7280",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1673 1.6665V3.74984M10.0007 1.6665V3.74984M5.83398 1.6665V3.74984",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2507 12.5002H12.9173M7.08398 8.3335H12.9173",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.33398 12.9165H7.08398C8.00446 12.9165 8.75065 13.6627 8.75065 14.5832V18.3332",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefIcon);
export default __webpack_public_path__ + "static/media/brief-icon.c7f7adc073ac8fa40344e3d0df9bef5b.svg";
export { ForwardRef as ReactComponent };